import { useMutation } from "@tanstack/react-query";
import { Tabs, message } from "antd";
import { useState } from "react";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";
import TabGiftCard from "../../../components/admin/tabsCatalog/TabGiftCard";
import TabMemberships from "../../../components/admin/tabsCatalog/TabMemberships";
import TabPackage from "../../../components/admin/tabsCatalog/TabPackage";
import TabProducts from "../../../components/admin/tabsCatalog/TabProducts";
import TabServices from "../../../components/admin/tabsCatalog/TabServices";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import {
  adminDeleteGiftCard,
  adminDeleteMembership,
  adminDeletePackage,
  adminDeleteProduct,
  adminDeleteServices,
} from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
const catalog = [
  "Services",
  "Packages",
  "Products",
  "Gift Cards",
  "Memberships",
];
const CatalogManagement = () => {
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [searchHeader, setSearchHeader] = useState<any>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isFilter, setIsFilter] = useState({});
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });
  const items: any = [
    {
      key: "1",
      label: (
        <div
          className={`tab-label px-4 py-2 font-semibold text-sm ${
            activeTabKey === "1"
              ? "bg-white rounded-lg "
              : " bg-transparent text-[#75757E] "
          }`}
        >
          Services
        </div>
      ),
      children: (
        <TabServices
          isFilter={isFilter}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchHeader={searchHeader}
        />
      ),
    },
    {
      key: "2",
      label: (
        <div
          className={`tab-label px-4 py-2 font-semibold text-sm ${
            activeTabKey === "2"
              ? "bg-white rounded-lg "
              : " bg-transparent text-[#75757E] "
          }`}
        >
          Packages
        </div>
      ),
      children: (
        <TabPackage
          isFilter={isFilter}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchHeader={searchHeader}
        />
      ),
    },
    {
      key: "3",
      label: (
        <div
          className={`tab-label px-4 py-2 font-semibold text-sm ${
            activeTabKey === "3"
              ? "bg-white rounded-lg "
              : " bg-transparent text-[#75757E] "
          }`}
        >
          Products
        </div>
      ),
      children: (
        <TabProducts
          isFilter={isFilter}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchHeader={searchHeader}
        />
      ),
    },
    {
      key: "4",
      label: (
        <div
          className={`tab-label px-4 py-2 font-semibold text-sm ${
            activeTabKey === "4"
              ? "bg-white rounded-lg "
              : " bg-transparent text-[#75757E] "
          }`}
        >
          Gift Cards
        </div>
      ),
      children: (
        <TabGiftCard
          isFilter={isFilter}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchHeader={searchHeader}
        />
      ),
    },
    {
      key: "5",
      label: (
        <div
          className={`tab-label px-4 py-2 font-semibold text-sm ${
            activeTabKey === "5"
              ? "bg-white rounded-lg "
              : " bg-transparent text-[#75757E]"
          }`}
        >
          Memberships
        </div>
      ),
      children: (
        <TabMemberships
          isFilter={isFilter}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchHeader={searchHeader}
        />
      ),
    },
  ];
  const itemsFilter = [
    0,
    { bySalon: true, dateAdded: true, gender: true },
    { bySalon: true, dateAdded: true, gender: true },
    { bySalon: true, dateAdded: true, stock: true },
    { bySalon: true, dateAdded: true, status3: true },
    { bySalon: true, dateAdded: true, gender: true },
  ];

  const showModalConfirm = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalConfirmOpen(true);
  };
  const closeModalConfirm = () => {
    setIsModalConfirmOpen(false);
  };
  const actionItems = [
    [
      {
        color: "#C43535",
        text: "Delete services",
        title: "Confirm Deletion",
        description: "Are you sure you want to delete this services?",
        status: "delete",
      },
    ],
    [
      {
        color: "#C43535",
        text: "Delete Packages",
        title: "Confirm Deletion",
        description: "Are you sure you want to delete this Packages?",
        status: "delete",
      },
    ],
    [
      {
        color: "#C43535",
        text: "Delete Products",
        title: "Confirm Deletion",
        description: "Are you sure you want to delete this Products?",
        status: "delete",
      },
    ],
    [
      {
        color: "#C43535",
        text: "Delete Gift Cards",
        title: "Confirm Deletion",
        description: "Are you sure you want to delete this Gift Cards?",
        status: "delete",
      },
    ],
    [
      {
        color: "#C43535",
        text: "Delete Memberships",
        title: "Confirm Deletion",
        description: "Are you sure you want to delete this Memberships?",
        status: "delete",
      },
    ],
  ];
  const breadcrumb = useBreadcrumb(
    [`catalog-management ( ${catalog[+activeTabKey - 1]} )`],
    1
  );

  const { mutate: deleteService } = useMutation(adminDeleteServices, {
    onSuccess: (res: any) => {
      if (res?.status !== 200) {
        message.error(res?.response?.data?.message);
        console.log(res);
      } else {
        console.log(res);
        message.success("services Deleted Successfully");
        queryClient.invalidateQueries(["services"]);
        closeModalConfirm();
      }
    },
  });
  const { mutate: deleteProduct } = useMutation(adminDeleteProduct, {
    onSuccess: (res: any) => {
      if (res?.status !== 200) {
        message.error(res?.response?.data?.message);
        console.log(res);
      } else {
        console.log(res);
        message.success("product Deleted Successfully");
        queryClient.invalidateQueries(["product"]);
        closeModalConfirm();
      }
    },
  });
  const { mutate: deleteMembership } = useMutation(adminDeleteMembership, {
    onSuccess: (res: any) => {
      if (res?.status !== 200) {
        message.error(res?.response?.data?.message);
        console.log(res);
      } else {
        console.log(res);
        message.success("membership Deleted Successfully");
        queryClient.invalidateQueries(["membership"]);
        closeModalConfirm();
      }
    },
  });
  const { mutate: deletePackage } = useMutation(adminDeletePackage, {
    onSuccess: (res: any) => {
      if (res?.status !== 200) {
        message.error(res?.response?.data?.message);
        console.log(res);
      } else {
        console.log(res);
        message.success("package Deleted Successfully");
        queryClient.invalidateQueries(["package"]);
        closeModalConfirm();
      }
    },
  });
  const { mutate: deleteGiftCard } = useMutation(adminDeleteGiftCard, {
    onSuccess: (res: any) => {
      if (res?.status !== 200 || res?.code === "ERR_BAD_REQUEST") {
        message.error(res?.response?.data?.message);
        console.log(res);
      } else {
        console.log(res);
        message.success("giftcard Deleted Successfully");
        queryClient.invalidateQueries(["giftcard"]);
        closeModalConfirm();
      }
    },
  });
  const catalogData: any = {
    Services: (data: any) => {
      console.log(data);

      deleteService(data);
    },
    Packages: (data: any) => {
      console.log(data);

      deletePackage(data);
    },
    Products: (data: any) => {
      console.log(data);

      deleteProduct(data);
    },
    "Gift Cards": (data: any) => {
      console.log(data);

      deleteGiftCard(data);
    },
    Memberships: (data: any) => {
      console.log(data);
      deleteMembership(data);
    },
  };
  const onChange = (key: string) => {
    setActiveTabKey(key);
    setIsFilter({});
    setSearchHeader("");
  };
  return (
    <>
      {breadcrumb}
      <div className="bg-[#EEF0FF] catalog-admin mt-20">
        <div className="flex items-center justify-end">
          <HeaderTableSuperAdmin
            hasModal={false}
            searchHeader={searchHeader}
            setSearchHeader={setSearchHeader}
            placeholderSearch="Search"
            selectedRowKeys={selectedRowKeys}
            modalId={0}
            setIsFilter={setIsFilter}
            filterType={itemsFilter[+activeTabKey]}
            actionItems={actionItems[+activeTabKey - 1]}
            confirmMessage={confirmMessage}
            requestDelete={catalogData[catalog[+activeTabKey - 1]]}
            setConfirmMessage={setConfirmMessage}
            isModalConfirmOpen={isModalConfirmOpen}
            closeModalConfirm={closeModalConfirm}
            showModalConfirm={showModalConfirm}
          />
        </div>
        <h4 className="text-color-primary translate-y-[130%] text-2xl font-semibold">
          Salons Catalogue
        </h4>
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTabKey}
          onChange={onChange}
          items={items}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </>
  );
};

export default CatalogManagement;
